import { IconButton } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import Snackbar from '@material-ui/core/Snackbar'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import EditIcon from '@material-ui/icons/Edit'
import MuiAlert from '@material-ui/lab/Alert'
import { list, setFavourite } from 'api/products/number-porting'
import CostPriceTableDisplay from 'components/CostPriceTableDisplay'
import ProductFavourite from 'components/ProductFavourite'
import useProductsList from 'hooks/ProductsList'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  pagination: {
    marginBottom: '60px',
  },
  fab: {
    margin: 0,
    top: 'auto',
    right: 20,
    bottom: 20,
    left: 'auto',
    position: 'fixed',
  },
})

function List(props) {
  const classes = useStyles()
  const { t } = useTranslation()

  const productsList = useProductsList({
    queryKey: 'number-porting-products',
    listFn: list,
    favouriteFn: setFavourite,
  })

  const handleChangePage = (event, other) => {
    productsList.setPage(other + 1)
  }

  const handleChangeRowsPerPage = event => {
    productsList.setPerPage(parseInt(event.target.value, 10))
  }

  const handleAddProductToFavourites = async id => {
    productsList.favouriteMutation.mutate({ id: id, value: true })
  }

  const handleRemoveProductFromFavourites = async id => {
    productsList.favouriteMutation.mutate({ id: id, value: false })
  }

  const getDisplayPrice = price => {
    if (price === 0) {
      return price.toFixed(2)
    } else if (price > 0) {
      return (price / 100).toFixed(2)
    }

    return ''
  }

  if (productsList.query.isInitialLoading) {
    return null
  }

  return (
    <div>
      <Typography variant='h3' gutterBottom>
        Number Porting
      </Typography>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Product Code</TableCell>
              <TableCell>{t('Upfront Cost')}</TableCell>
              <TableCell>{t('Monthly Cost')}</TableCell>
              <TableCell>{t('Upfront RRP')}</TableCell>
              <TableCell>{t('Monthly RRP')}</TableCell>
              <TableCell align='right'></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {productsList.query.data.data.map(row => (
              <TableRow key={row.id}>
                <TableCell scope='row'>{row.name}</TableCell>
                <TableCell scope='row'>{row.product_code}</TableCell>
                <TableCell scope='row'>
                  <CostPriceTableDisplay
                    value={getDisplayPrice(row.upfront_cost_price)}
                  />
                </TableCell>
                <TableCell scope='row'>
                  <CostPriceTableDisplay
                    value={getDisplayPrice(row.monthly_cost_price)}
                  />
                </TableCell>
                <TableCell scope='row'>{getDisplayPrice(row.upfront_rrp)}</TableCell>
                <TableCell scope='row'>{getDisplayPrice(row.monthly_rrp)}</TableCell>
                <TableCell align='right'>
                  <ProductFavourite
                    productId={row.id}
                    isFavourite={row.is_favourite}
                    onAdd={handleAddProductToFavourites}
                    onRemove={handleRemoveProductFromFavourites}
                  />
                  <IconButton
                    aria-label='edit'
                    color='default'
                    component={NavLink}
                    to={`/products/number-porting/update/${row.id}`}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        className={classes.pagination}
        rowsPerPageOptions={[5, 15, 25]}
        component='div'
        count={productsList.query.data.meta.total}
        rowsPerPage={parseInt(productsList.query.data.meta.per_page)}
        page={productsList.query.data.meta.current_page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <Snackbar
        open={productsList.snackbarOpen}
        autoHideDuration={6000}
        onClose={productsList.handleSnackbarClose}>
        <MuiAlert
          elevation={6}
          variant='filled'
          onClose={productsList.handleSnackbarClose}
          severity={productsList.snackbarSeverity}>
          {productsList.snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  )
}

export default List
